import Alert from '@/components/Alert.vue';

import Vue from 'vue';

const showAlert = Vue.extend(Alert);

function newAlert(options,cB) {
			options.resp = cB || (() => {});
			new showAlert({
					propsData: options
	 			}).$mount()
}

newAlert.setColors = ( client ) => {
	//console.log('setNewAlert',client);
	newAlert.btnColor = client.btnColor;
	newAlert.btnFontColor = client.btnFontColor;
}

newAlert.yesno = ( message, cB ) => {
	newAlert({
		header: 'Confirm',
		message: message,
		OK: 'yes',
		cancel: 'no',
		btnColor: newAlert.btnColor,
		btnFontColor: newAlert.btnFontColor,
	},cB);
}

newAlert.message = ( message, cB ) => {
	newAlert({
		header: 'Message',
		message: message,
		OK: 'OK',
		cancel: '',
		btnColor: newAlert.btnColor,
		btnFontColor: newAlert.btnFontColor,
	},cB)
}

newAlert.confirm = ( message, cB ) => {
	newAlert({
		header: 'Confirm',
		message: message,
		OK: 'OK',
		cancel: 'Cancel',
		btnColor: newAlert.btnColor,
		btnFontColor: newAlert.btnFontColor,
	},cB)
}

newAlert.error = ( message, cB ) => {
	newAlert({
		header: 'Error',
		message: message,
		OK: 'OK',
		cancel: '',
		error: true,
		btnColor: newAlert.btnColor,
		btnFontColor: newAlert.btnFontColor,
	},cB)
}

newAlert.prompt = ( message, cB ) => {
	if ( typeof message == 'object' ) {
		var type = message.type;
		message = message.message
	}
	newAlert({
		header: 'Prompt',
		message: message,
		OK: 'OK',
		cancel: 'Cancel',
		input: '',
		type: type,
		btnColor: newAlert.btnColor,
		btnFontColor: newAlert.btnFontColor,
	},cB);
}

export default newAlert;